const state = {
  userData: null,
  token: {
    accessToken: null,
    refreshToken: null
  },
}

export default state
